import _filter from 'lodash/filter';
import _isArray from 'lodash/isArray';
import _map from 'lodash/map';

/**
 * Normalizes dealership list payloads from rockedAdmin (raw array or { dealerships }).
 */
export function normalizeDealershipListResult(result) {
  if (result == null) {
    return [];
  }
  if (_isArray(result)) {
    return result;
  }
  if (_isArray(result.dealerships)) {
    return result.dealerships;
  }
  return [];
}

/**
 * Plan / contest dealership rows may use `selected` (boolean or 0/1) or legacy `isSelected`.
 */
export function isDealershipRowSelectedInApi(row) {
  if (!row || typeof row !== 'object') {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(row, 'selected')) {
    return row.selected === true || row.selected === 1;
  }
  return row.isSelected === true || row.isSelected === 1 || Boolean(row.isSelected);
}

/**
 * IDs where the API marked the row as selected for this plan/context.
 */
export function getDealershipIdsWithSelectedFlag(dealerships) {
  if (!_isArray(dealerships) || dealerships.length === 0) {
    return [];
  }
  const selectedRows = _filter(dealerships, isDealershipRowSelectedInApi);
  return _map(selectedRows, 'id');
}
